import { OrgName } from './org-name';
import { OrgLogo } from './org-logo';
import { OrgAssetMode } from './org-asset-mode';
import { WorkflowSoftwareRepository } from './workflow-software-repository';
import { PageTitle } from '@/components/page-title';
import { PageDescription } from '@/components/page-description';

export const GeneralSettingsPage = () => {
  return (
    <div className='w-full'>
      <div className='mb-6'>
        <PageTitle id='org-settings-title' title='Organization settings' />
        <PageDescription>
          Manage your organization's identity and workflow defaults in Capitol
          AI.
        </PageDescription>
      </div>
      <div className='flex flex-col gap-4'>
        <OrgName />
        <OrgLogo />
        <OrgAssetMode />
        <WorkflowSoftwareRepository />
      </div>
    </div>
  );
};
